import { getBuyerId } from 'dibs-cookie-jar';
import { isEmailOnly } from 'dibs-cookie-jar/exports/isEmailOnly';
import authModalLoader from './AuthModalLoader';
import {
    getPasswordToken,
    getUserEmailToken,
} from '../authModal/authentication/userStoragePasswordToken';
import { getEmailTokenFromQuery } from '../utils/userTracking';
import { verifyEmailHandler } from './verifyEmailHandler';

const authModals = [
    authModalLoader.constants.LOGIN,
    authModalLoader.constants.REGISTER,
    authModalLoader.constants.RESET_PASSWORD,
    authModalLoader.constants.REQUEST_PASSWORD_EMAIL,
];

const verifyEmailFlows = authModalLoader.constants.verifyEmailFlows;

/**
 *
 * @param uri
 * @returns {string}
 */
function getRedirectDestination() {
    let dest = new URLSearchParams(window.location.search).get('ep');
    if (dest && dest.indexOf('//') > -1) {
        // id ep contains '//' then redirect to current page
        // if phishing is happening, just redirect to the homepage (uri.path = '/')
        dest = window.location.href;
    }

    return dest && decodeURIComponent(dest);
}

function isValidAction(action) {
    if (
        action === authModalLoader.constants.RESET_PASSWORD &&
        !getPasswordToken() &&
        !getUserEmailToken() &&
        !getEmailTokenFromQuery()
    ) {
        return false;
    }

    return action && authModals.indexOf(action) > -1;
}

/**
 * @param {object} environment Mock object mainly for testing
 */
export async function triggerAuthModal(environment) {
    const destination = getRedirectDestination();
    const searchParams = new URLSearchParams(window.location.search);
    let action = searchParams.get('modal') || '';
    const gaAction = action.replace('_', ' ');
    const email = searchParams.get('email') || '';
    action = action.replace(/_/g, '-');
    const flow = searchParams.get('flow') || authModalLoader.constants.DEFAULT_FLOW;
    const authOptions = {
        action: action,
        flow,
        email,
        ga: {
            label: gaAction + ' query param - address bar',
            value: window.scrollY ? 1 : 0,
        },
    };

    if (isValidAction(action)) {
        if (
            verifyEmailFlows.includes(flow) &&
            action === authModalLoader.constants.RESET_PASSWORD
        ) {
            verifyEmailHandler({ environment, flow, email, destination });
        }
        // Need to make sure we have fresh user state
        // and don't get into infinite redirect loops
        else if (
            getBuyerId(document.cookie) &&
            destination &&
            !isEmailOnly(document.cookie) // don't want to redirect yet if you are email only user creating password or login in with email token
        ) {
            window.location.href = destination;
        } else {
            const authResponse = await authModalLoader.show(authOptions);
            if (destination && !authResponse.err) {
                window.location.href = destination;
            }
        }
    }
}
